
<!-- <dashboardnav>
</dashboardnav> -->
    <!-- MAIN MAIN=================================MAIN MAIN=======================================MAIN MAIN======================= -->
<div
*ngIf="(categoryloading$ | async) === false && (isloadingTemplate$ | async) === false ">
  <cradua-pl-stage-activity
    [plstageactivities]="plstageactivities$ | async"
    [plstakeholdersmatrix]="plstakeholdersmatrix$ | async"
     [identityusers]="identityusers$ | async"
    [plstakeholdersmatrixraci]="plstakeholdersmatrixraci$ | async"
    [plrstageactivies]="plrstageactivies$ | async"
    [actionpersons]="actionpersons$ | async"
    [stagecategories]="stagecategories$ | async"
    [templates]="templates$ | async"
    [stages]="pipelinelicensestages$ | async"
    (deleteventActivity)="onDeleteActivity($event)"
    (deleteventMatrix)="onDeleteMatrix($event)"
    (deleteventRaci)="onDeleteMatrixRaci($event)"
    (deleteventStage)="onDeleteStage($event)"
    (deletePlrsEvent)="onDeletePlrStage($event)"
    [racies]="hierarchys$ | async"
    [selectedData]="selectedData"
    [stakeholders]="pipelinelicensestakeholders$ | async"
    (addplstageevent)="onSubmitStage($event)"
    (viewTemplateEvent)="viewTemplate($event)"
    *ngIf="isVeiwTemplate" 
    >
  </cradua-pl-stage-activity>

  <cradua-template
  *ngIf="!isVeiwTemplate" 
  [plstageactivities]="plstageactivities$ | async"
  [plstakeholdersmatrix]="plstakeholdersmatrix$ | async"
  [plstakeholdersmatrixraci]="plstakeholdersmatrixraci$ | async"
   [stagecategories]="stagecategories$ | async"
  [templates]="templates$ | async"
  [stages]="pipelinelicensestages$ | async"
  (deletevent)="onDeleteTemplate($event)"
  (submitevent)="onSubmitTemplate($event)"
  (isTemplateview)="viewTemplate($event)"
  >
</cradua-template>

</div>
<!-- (isLoading$ | async) === false &&  (isLoadingStage$ | async) === false
((isLoading$ | async) === true || (isLoadingStage$ | async) === true ) -->

  <mrsoftapps-epims-reference-spinner *ngIf="
 (categoryloading$ | async) === true || (isloadingTemplate$ | async) === true
 ">
    </mrsoftapps-epims-reference-spinner>

    <div class="box green_box"></div>
    <div class="box pink_box"></div>
    <!-- <script src="sass/vendors/epims.js"></script> -->


